export const removeHtmlElementFromString = (s: string, element: keyof JSX.IntrinsicElements) =>
  s.replace(new RegExp(`<${element}>`, 'g'), '').replace(new RegExp(`</${element}>`, 'g'), '');
